import React, { useState } from 'react';

import { useTranslation, Trans } from "react-i18next";

function Faq () {

    const { t } = useTranslation();

    const data = [
        {
            title: t('bonus.20'),
            description: t('bonus.21'),
        },
        {
            title: t('bonus.22'),
            description: t('bonus.23'),
        },
        {
            title: t('bonus.24'),
            description: t('bonus.25'),
        },
        {
            title: t('bonus.26'),
            description: t('bonus.27'),
        },
        {
            title: t('bonus.28'), 
            description: t('bonus.29'),
        }
    ]

    const [activeIndex, setActiveIndex] = useState(null);

    const toggle = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };
      
    return(
        <div className="overflow-hidden relative pt-[80px] xl:pt-[160px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
                <div className="flex flex-col md:flex-row justify-between xl:items-center gap-[20px]">
                    <div>
                        <p className="text-[30px] xl:text-[40px] italic font-[700] merriweather"><Trans>{t('bonus.30')}</Trans></p>
                    </div>
                </div>
                <div className='mt-[50px]'>
                    {data.map((item, index) => (
                        <div
                            key={index}
                            className="border-b border-gray-300 py-4"
                        >
                        <div
                            className="flex justify-between items-center cursor-pointer"
                            onClick={() => toggle(index)}
                        >
                            <h3 className="inter text-[16px] xl:text-[18px] font-[500]">{item.title}</h3>
                            <span className="text-xl">
                                <svg className={`${activeIndex == index ? 'rotate-45' : ''} transition-all`} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                    <path d="M31.3333 20.6699H20.668V31.3333H18.668V20.6699H8V18.6699H18.668V7.99998H20.668V18.6699H31.3333V20.6699Z" fill="black"/>
                                </svg>
                            </span>
                        </div>

                        {activeIndex === index && (
                            <div className="mt-2 space-y-2">
                                <p className='xl:max-w-[838px] inter text-[14px] xl:text-[16px] font-[300]'>{item.description}</p>
                            </div>
                        )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Faq;